export enum Notification {
  RECEIVING = 'receiving',
  SENDING = 'sending',
}

export enum Sites {
  APPROVED = 'approved',
  UNAPPROVED = 'unapproved',
  MAP = 'map',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
  NEW_ENTRANTSENDOFF = 'new-entrantSendoff',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  EducationStatus = 'educationStatus',
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
  SendPhoto = 'sendPhoto',
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
}

export enum Site {
  WORK_STATUS = 'work-status',
  ALBUMS = 'albums',
  WORK_INFO = 'work-info',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
  NEW_ENTRANTSENDOFF = 'new-entrantSendoff',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  EducationStatus = 'educationStatus',
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
  SendPhoto = 'sendPhoto',
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
}

export enum Business {
  WORK_STATUS = 'work-status',
  WORKER_INFO = 'worker-info',
}

export enum SupportSite {
  AGENT = 'agent',
  CHARGE = 'charge',
  MAP = 'map',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
  NEW_ENTRANTSENDOFF = 'new-entrantSendoff',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  EducationStatus = 'educationStatus',
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
  SendPhoto = 'sendPhoto',
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
}
export enum WorkerShiftConstant {
  PLANNED_WORK_SITES = 'planned-work-sites',
  WORKER_SHIFT_TABLES = 'worker-shift-table',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
  NEW_ENTRANTSENDOFF = 'new-entrantSendoff',
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  EducationStatus = 'educationStatus',
  // 2023/12/28 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
  SendPhoto = 'sendPhoto',
  // 2024/01/05 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
}
